export default "__VITE_ASSET__DOI3vgFO__"